export const NAVIGATION_DRAWER_WIDTH = { xs: 200, lg: 190 };

export const TOOLBAR_HEIGHT = { xs: '56px', md: '64px' };
